export const SENTRY_DSN =
  'https://37e2b4d5349d00da566002cafa518901@o528969.ingest.us.sentry.io/4510894404141056'

/** Encrypted token. Yes it's hardcoded. */
export const ENCRYPTED_STORAGE_TOKEN =
  'vMdzMGKj7/hswawmAOOjI1FcquqRlca6ojsDecPq87lekax3cL636UHQ485N2sxQfQaFs5Ual8WktsfZeRGAPvsZaCR9f1Yufu2uzG/IHO8sbcpCbedhmK0vXzTiNkHGb2gyro6QzZzR588f0UxrKRdiPeHK+UcuSY+g5IFZ25xesBNPIPecjaUPm/sJ4beaSFBlo6qHI0N34YId7jZTX5QPVHLAJp/hWtsli+4UWFOIIWl1DLKyUl4cR+wtntMpbWwBcgnjni+cz5UYESbQ9jqtRTMgv4SA4lpJITB06vM='

export const SANITY_PROJECT_ID = 'ptaeklkh'
export const SANITY_DATASET = 'production'
export const SANITY_API_VERSION = '2026-01-18'
